import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import {
  BreadcrumbsParams,
  BreadcrumbsService,
  BreadcrumbsServiceSymbol,
  ReportsComponentTileFilterBreadcrumbSync,
  ReportsFilterBreadcrumb,
} from '@core/reports-types';
import { getComponentDatePoint } from '@core/reports-util';

@Injectable()
export class DatePointsBreadcrumbsService implements BreadcrumbsService<'datePoints'> {
  public [BreadcrumbsServiceSymbol] = <const>'datePoints';
  private i18n = inject(I18nService);

  public getBreadcrumbsSync({
    data,
    metric,
  }: BreadcrumbsParams): ReportsComponentTileFilterBreadcrumbSync[] {
    const startPoint = getComponentDatePoint(data, metric, 'startPoint');
    const endPoint = getComponentDatePoint(data, metric, 'endPoint');
    if (!startPoint || !endPoint) {
      return [];
    }

    return [
      this.getDatePointBreadcrumb(startPoint.name, 'start'),
      this.getDatePointBreadcrumb(endPoint.name, 'end'),
    ];
  }
  public getBreadcrumbs(params: BreadcrumbsParams): ReportsFilterBreadcrumb[] {
    return this.getBreadcrumbsSync(params);
  }

  private getDatePointBreadcrumb(
    label: string,
    point: 'start' | 'end',
  ): ReportsComponentTileFilterBreadcrumbSync {
    return {
      simple: false,
      hasOverwrites: false,
      invalid: false,
      translatedGroup:
        point === 'start'
          ? this.i18n.translate('tlr.date_point.start_point')
          : this.i18n.translate('tlr.date_point.end_point'),

      translatedValues: [
        {
          label,
        },
      ],
    };
  }
}
